import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: Provider = {
  ProviderID: null,
  FullName: '',
  Status: '',
  UiPosition: null,
  ImageUrl: '',
  LastSyncedAt: null,
  ConnectTitle: '',
  ConnectionDescription: '',
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    FullName: '',
    ConnectTitle: '',
    ConnectionDescription: ''
  },
  translations: {
    FullName: '',
    ConnectTitle: '',
    ConnectionDescription: '',
    LanguageCode: null
  }
}
export const providerSlice = createSlice({
  name: 'provider',
  initialState,
  reducers: {
    setProviderInfo: (state, action: PayloadAction<Provider>) => {
      return {
        ...state,
        ...action.payload
      }
    },
    setProviderSelectedTranslations: (
      state,
      action: PayloadAction<SetProviderTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          FullName: action.payload.translations?.FullName ?? null,
          ConnectTitle: action.payload.translations?.ConnectTitle ?? null,
          ConnectionDescription:
            action.payload.translations?.ConnectionDescription ?? null
        }
      }
    }
  }
})
export const { setProviderInfo, setProviderSelectedTranslations } =
  providerSlice.actions
export const providerReducer = providerSlice.reducer
